import { PromoBadge } from '@/components/PromoBadge';
import { VideoPlayer } from '@/components/VideoPlayer';
import type { Image, PromoBadge as Badge } from '@/types';
import { Item } from './ImageCarousel.styled';

interface CarouselItemProps {
  image: Image;
  isBook: boolean;
  offset?: number;
  promoBadge?: Badge;
}

export const CarouselItem = ({
  image: { altText, captionsSrc, mainSrc, videoSrc },
  isBook,
  offset,
  promoBadge,
}: CarouselItemProps) => (
  <Item $isBook={isBook} $offset={offset} key={mainSrc ?? videoSrc}>
    {videoSrc ? (
      <VideoPlayer
        captions={captionsSrc ?? null}
        poster={mainSrc ?? undefined}
        src={videoSrc}
      />
    ) : (
      <>
        <img alt={altText ?? ''} src={mainSrc ?? ''} />
        {promoBadge ? (
          <PromoBadge altText={promoBadge.altText} src={promoBadge.src} />
        ) : null}
      </>
    )}
  </Item>
);
